import React, { Component } from 'react';
import _unescape from 'lodash/unescape';

export class ResultEntry extends Component {

  state = {
    imgOk:true
  }

  stockLevelCss(level) {
    switch (level) {
      case 0:
        return "badge badge-pill badge-primary";
      case 1:
        return "badge badge-pill badge-danger";
      case 2:
        return "badge badge-pill badge-warning";
      case 3:
        return "badge badge-pill badge-success";
      default :
        return "badge badge-pill badge-dark";

    }
  }

  stockLevelLabel(level) {
    switch (level) {
      case 0:
        return "Unknown";
      case 1:
        return "No Stock";
      case 2:
        return "Low Stock";
      case 3:
        return "In Stock";
     default:
        return "See Info";

    }
  }

  openStore = item => {
    
  }

  render() {
//<i className="fas fa-globe-europe align-self-center"></i>
    const { value: item } = this.props;
    return (
      <div className="row result-entry mb-3 p-sm-2">

        <div className="col-2 col-sm-1 pl-2 pr-2 d-flex align-items-center text-center clickable" onClick={() => this.props.onShowProduct(item)} >
          {this.state.imgOk && <img className="img-fluid" alt={item.description} src={_unescape(item.imageUrl)} onError={() => { this.setState({ imgOk: false }) }} />}
          {!this.state.imgOk && <i className="fas fa-bomb margin-l-auto"></i>}
        </div>

        <div className="col-6 col-sm-8 col-md-7 p-0 d-flex align-items-center clickable" >

          <div>
            <div dangerouslySetInnerHTML={{ __html: item.descriptionMatch.formattedString }} onClick={() => this.props.onShowProduct(item)}></div>
            {item.sku && <div className="sku badge badge-info mr-2 clickable" onClick={() => this.props.onSelect(item.sku)}><i className="fas fa-search clickable mr-1"></i>{item.sku}</div>}
            <div className="badge badge-secondary" onClick={() => this.props.onShowProduct(item.productPageUrl)}>{item.store} </div>
          </div>

          
        </div>
        
        <div className="col col-sm-2 col-md-3 p-0 d-flex align-items-center clickable" onClick={() => this.props.onShowProduct(item)}>

          <div className="container p-0">
            <div className="row">
              <div className="col col-sm p-0 text-right">
                <div className=" col align-self-center"><span className="pound">£</span>{item.price === 0 ? <span className="price-na">N/A</span> : <span className="price">{item.price.toFixed(2)}</span>}</div>

              </div>
              <div className="col col-sm p-0 text-right">
                <div className=" col align-self-center"><span className={this.stockLevelCss(item.inStock)}>{this.stockLevelLabel(item.inStock)}</span></div>

              </div>
            </div>
          </div>
    
        </div>

        <div className="col-auto col-sm-1 p-2 d-flex align-items-center text-center">
          <a className="result-link" href={_unescape(item.productPageUrl)} rel="noopener noreferrer" target="_blank">
            
            <i className="fas fa-external-link-alt align-self-center"></i>
            <div className="d-none d-sm-block">Visit store</div>
          </a>
        </div>
      </div>
    );
  }
}
